interface ISuccessDialogProps {
    onConfirm?: () => void;
    title: string;
    description: string;
    confirmBtnLabel?: string;
}

const AccountActivated = ({ title, description, onConfirm, confirmBtnLabel = "Continue" }: ISuccessDialogProps) => {
    return <div className="-mx-3 lg:-mx-6 -mt-[1rem] rounded-md">
        <div className=" rounded-sm flex flex-col">
            <div className="py-10">
                <div className="flex justify-center items-center">
                    <svg className="w-16 h-auto lg:w-20" viewBox="0 0 72 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.15">
                            <path d="M50.625 7.5L22.5 35.625L9.375 22.5L0 31.875L22.5 54.375L60 16.875L50.625 7.5Z" fill="black" />
                        </g>
                        <path d="M62.625 9.5L34.5 37.625L21.375 24.5L12 33.875L34.5 56.375L72 18.875L62.625 9.5Z" fill="green" />
                    </svg>
                </div>
            </div>
            <div className="bg-white p-10 px-6">
                <p className="text-center  font-semibold text-3xl text-black">{title}</p>
                <p className="text-center text-lg">{description}</p>

                {onConfirm && (
                    <div className="mt-6 lg:mt-10 flex justify-center mx-14 mb-3">
                        <button onClick={onConfirm} className="bg-[#FBC02D] px-16 lg:px-24 font-medium text-lg font-robotoCondensed py-2 lg:py-4 text-[#002E2E] rounded-md">
                            {confirmBtnLabel}
                        </button>
                    </div>
                )}
            </div>

        </div>
    </div>
};

export default AccountActivated;
